'use strict';

const { getConfig } = require('../common/jsConfig');

function searchCountries(element, $searchInput) {
    $(element).find('.js-phonecountrycode-list-item a').filter(function () {
        return $(this).parent().toggle($(this).text().toUpperCase().indexOf($searchInput.val().toUpperCase()) > -1);
    });
}
function updatePhoneNumber($phoneLocal, $phoneCountryCodeInput, $phoneInput, defaultPhoneCountryCodeValue) {
    const isDefaultLocaleSelected = defaultPhoneCountryCodeValue === $phoneCountryCodeInput.val();
    let localPhoneValue = $phoneLocal.val();
    const phoneCountryCodeValue = $phoneCountryCodeInput.data('value');
    if (isDefaultLocaleSelected && localPhoneValue.length && localPhoneValue[0] === '0') {
        localPhoneValue = localPhoneValue.substring(1);
    }
    if (phoneCountryCodeValue && localPhoneValue) {
        $phoneInput.val(phoneCountryCodeValue + localPhoneValue);
    } else {
        $phoneInput.val('');
    }
}

function resolveSelectedPhoneCountryCodeItem($phoneCountryCodeList, selectedCountryCode, fallbackCountryCode) {
    if (selectedCountryCode) {
        const $selectedById = $phoneCountryCodeList.find(`[id="${selectedCountryCode}"]`);

        if ($selectedById.length) {
            return $selectedById;
        }

        const $selectedByDialCode = $phoneCountryCodeList.find(`[data-value="${selectedCountryCode}"]`).first();

        if ($selectedByDialCode.length) {
            return $selectedByDialCode;
        }
    }

    if (fallbackCountryCode) {
        const $fallbackById = $phoneCountryCodeList.find(`[id="${fallbackCountryCode}"]`);

        if ($fallbackById.length) {
            return $fallbackById;
        }
    }

    return $phoneCountryCodeList.find('.js-phonecountrycode-list-item').first();
}

module.exports = {
    init: function () {
        $('.js-phone-input-group').each((index, element) => {
            const searchInput = $(element).find('#searchCountryName');
            const $phoneInput = $(element).find('.js-phone');
            const $phoneCountryCodeInput = $(element).find('.js-phonecountrycode');
            const $phoneCountryCodeSelectedBtn = $(element).find('.js-phone-country-code-selected-btn');
            const $phoneCountryCodeListItem = $(element).find('.js-phone-country-code-list');
            const $phoneLocal = $(element).find($('.js-phone-local'));
            const selectedCountryCode = $phoneCountryCodeInput.data('selectedCountryCode') || $phoneCountryCodeInput.val();
            const $defaultPhoneCountryCodeListItem = $phoneCountryCodeListItem.find('[data-default="true"]');
            const defaultPhoneCountryCodeValue = $defaultPhoneCountryCodeListItem?.id || getConfig('defaultCountryCode');
            const $selectedPhoneCountryCodeListItem = resolveSelectedPhoneCountryCodeItem(
                $phoneCountryCodeListItem,
                selectedCountryCode,
                defaultPhoneCountryCodeValue
            );
            const phoneCountryCodePrefix = $selectedPhoneCountryCodeListItem.data('value') || $defaultPhoneCountryCodeListItem.data('value');

            $phoneCountryCodeListItem.find('.js-phonecountrycode-list-item').removeClass('selected');
            $selectedPhoneCountryCodeListItem.addClass('selected');
            $phoneCountryCodeInput.val($selectedPhoneCountryCodeListItem.attr('id'));
            $phoneCountryCodeInput.data('value', phoneCountryCodePrefix);
            $phoneCountryCodeSelectedBtn.text($selectedPhoneCountryCodeListItem.data('value'));

            updatePhoneNumber($phoneLocal, $phoneCountryCodeInput, $phoneInput, defaultPhoneCountryCodeValue);

            $phoneCountryCodeListItem.on('click', '.dropdown-item', function (event) {
                event.preventDefault();
                const countryCode = $(this).closest('.js-phonecountrycode-list-item').data('value');
                $phoneCountryCodeListItem.find('.js-phonecountrycode-list-item').removeClass('selected');
                $(this).closest('.js-phonecountrycode-list-item').addClass('selected');
                $phoneCountryCodeSelectedBtn.text(countryCode);
                $phoneCountryCodeInput.val($(this).closest('.js-phonecountrycode-list-item').attr('id'));
                $phoneCountryCodeInput.data('value', countryCode);
                $phoneCountryCodeInput.removeClass('is-invalid');
                updatePhoneNumber($phoneLocal, $phoneCountryCodeInput, $phoneInput, defaultPhoneCountryCodeValue);
            });

            $(element).find('#searchCountryName').on('keyup', function () {
                searchCountries(element, searchInput);
            });

            $(element).on('shown.bs.dropdown', function () {
                searchInput.val('');
                $phoneCountryCodeListItem.scrollTop(0);
                searchCountries(element, searchInput);
            });

            $phoneLocal.on('blur', function () {
                updatePhoneNumber($(this), $phoneCountryCodeInput, $phoneInput, defaultPhoneCountryCodeValue);
            });

            const observer = new MutationObserver(()=> {
                const $countryCodeInput = $(element).find('.js-phonecountrycode');
                if ($countryCodeInput.hasClass('is-invalid') && $countryCodeInput.val() === '') {
                    $phoneCountryCodeSelectedBtn.addClass('border-danger');
                } else {
                    $countryCodeInput.next('.invalid-feedback').html('');
                    $phoneCountryCodeSelectedBtn.removeClass('border-danger');
                }
            });

            if ($phoneCountryCodeInput) {
                observer.observe($phoneCountryCodeInput[0], {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
        });
    }
};
